import { Injectable       } from '@angular/core';
import { BehaviorSubject  } from 'rxjs/BehaviorSubject';

@Injectable()
export class TimeService {

  public years$: BehaviorSubject<number[]> = new BehaviorSubject([]);

  constructor() {
    const today = new Date();
    const result = [];
    for ( let year = 2004; year <= today.getFullYear(); year++ ) {
      result.push( year );
    }
    this.years$.next( result.reverse() );
  }

  selectYearsFetchAll() {
    return this.years$.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/time.service.ts